/* @flow */
import * as React from 'react';

import {AttributionReportDescription} from './attribution/attribution-report-description';
import {
    SALES,
    NEW_LEADS,
    LOSSES,
    CUSTOM,
    FORECAST,
    ACTIVITY,
    EMAIL,
    ATTRIBUTION,
    FUNNEL,
    TASKS,
    ENGAGEMENT,
} from './report-constants';

export const getAttributionReportDescription = () => <AttributionReportDescription />;

export function shouldShowReportControls(reportKey: string): boolean {
    return (
        reportKey === SALES ||
        reportKey === NEW_LEADS ||
        (reportKey === EMAIL && NutClientConfig.hasEmailReport) ||
        (reportKey === TASKS && NutClientConfig.hasTaskReport) ||
        (reportKey === ATTRIBUTION && NutClientConfig.hasAttributionReport) ||
        (reportKey === ACTIVITY && NutClientConfig.hasActivityReport) ||
        (reportKey === ENGAGEMENT && NutClientConfig.hasEngagementReportFF) ||
        ((reportKey === FORECAST || reportKey === CUSTOM || reportKey === LOSSES) &&
            NutClientConfig.hasOnDemandReporting)
    );
}

export function shouldShowReportDownloadAndSave(reportKey: string): boolean {
    return (
        reportKey === SALES ||
        reportKey === NEW_LEADS ||
        (reportKey === EMAIL && NutClientConfig.hasEmailReport) ||
        (reportKey === ATTRIBUTION && NutClientConfig.hasAttributionReport) ||
        (reportKey === ACTIVITY && NutClientConfig.hasActivityReport) ||
        (reportKey === TASKS && NutClientConfig.hasTaskReport) ||
        (reportKey === FUNNEL && NutClientConfig.hasFunnelReport) ||
        ((reportKey === FORECAST || reportKey === CUSTOM || reportKey === LOSSES) &&
            NutClientConfig.hasOnDemandReporting)
    );
}
